module.exports = __webpack_public_path__ + "img/审核通过.28c137b5.png";